function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "lock_icon",
  "data-name": "lock icon",
  transform: "translate(-17612 -267)"
}, /*#__PURE__*/React.createElement("path", {
  id: "lock_icon-2",
  "data-name": "lock icon",
  d: "M17621,273h-5v-1.569a2.5,2.5,0,0,1,5,0Zm-2.5,7a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,17618.5,280Zm4.875-7.333h-.812v-1.619a4.063,4.063,0,0,0-8.125,0v1.619h-.814a1.627,1.627,0,0,0-1.623,1.619v8.1a1.627,1.627,0,0,0,1.623,1.619h9.752a1.627,1.627,0,0,0,1.625-1.619v-8.1A1.628,1.628,0,0,0,17623.375,272.667Z",
  fill: "#e6e6e6"
}));

var SvgLockIcon = function SvgLockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock_icon.951b4f76.svg";
export { ForwardRef as ReactComponent };